import React from 'react'
import dynamic from 'next/dynamic'
import { STATIC_PAGES } from '@consts/index'
import { PageProps } from '@components/pages/dynamic'
import { SizingWidgetData } from '@helpers/products/sizingWidgetData'
import { EmptyObject } from 'types/helpers'

const DynamicPages = dynamic(() => import('@components/pages/dynamic'))
const StaticPages = dynamic(() => import('@components/pages/static'))

type PagesProps = {
  handle: string
  page: PageProps[]
  sizingWidgetData?: SizingWidgetData | EmptyObject
}

function Pages({ handle, page, sizingWidgetData }: PagesProps) {
  const staticPage = STATIC_PAGES.find(
    staticPage => staticPage.handle === handle
  )

  if (staticPage) {
    return (
      <StaticPages
        pagesHandle={staticPage.handle.replace('/', '')}
        sizingWidgetData={sizingWidgetData}
      />
    )
  }
  return <DynamicPages page={page} handle={handle} />
}

export default Pages
